import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Berapa lama proses pembuatan kartu?',
      answer:
        'Proses pembuatan kartu memakan waktu 5-7 hari kerja untuk order reguler. Untuk order dengan jumlah besar (500+ kartu), waktu produksi sekitar 7-10 hari kerja. Waktu produksi dapat berubah tergantung jumlah order dan kompleksitas desain.',
    },
    {
      question: 'Apakah aplikasi benar-benar gratis?',
      answer:
        'Ya, 100% gratis selamanya! Tidak ada biaya langganan, tidak ada hidden cost. Anda hanya membayar kartu fisik PVC/Digital-nya saja. Aplikasi web, dashboard, dan semua fitur sudah termasuk tanpa biaya tambahan. Update aplikasi juga gratis.',
    },
    {
      question: 'Berapa minimum order untuk kartu?',
      answer:
        'Minimum order kami sangat fleksibel, mulai dari 10 kartu untuk order reguler. Untuk custom design dengan printing full color, minimum order adalah 50 kartu. Kami juga menerima sample order 1-5 kartu dengan harga khusus untuk pengecekan kualitas.',
    },
    {
      question: 'Apakah bisa custom desain kartu?',
      answer:
        'Tentu saja! Anda bisa mengirimkan desain sendiri dalam format AI, PSD, atau PDF, atau memilih dari template desain yang sudah kami sediakan. Format kartu standar CR80 (85.6mm x 54mm) dengan ketebalan 0.76mm.',
    },
    {
      question: 'Bagaimana cara integrasi dengan sistem yang sudah ada?',
      answer:
        'Aplikasi kami dilengkapi dengan API documentation lengkap untuk integrasi dengan sistem existing Anda (SISFO, ERP, dll). Tim support kami siap membantu proses integrasi. Untuk integrasi khusus, tersedia layanan custom development dengan biaya terpisah.',
    },
    {
      question: 'Apa perbedaan kartu Digital dan barcode?',
      answer:
        'Kartu barcode menggunakan scan optik (harus terlihat), lebih ekonomis. Kartu ScanKartu menggunakan gelombang radio (tidak perlu line of sight), lebih cepat dan tahan lama. Pilihan tergantung kebutuhan: barcode untuk budget terbatas, ScanKartu untuk kecepatan dan durability.',
    },
    {
      question: 'Bagaimana cara pemesanan?',
      answer:
        'Hubungi kami via WhatsApp di 0852-3566-2062 atau email. Konsultasikan kebutuhan Anda (jenis kartu, jumlah, desain). Kami akan berikan penawaran harga. Setelah deal, kirimkan data dan desain. Setelah kartu jadi, kami kirim ke alamat Anda dengan ekspedisi terpercaya.',
    },
    {
      question: 'Apakah kartu bisa dikirim ke luar kota?',
      answer:
        'Ya, kami melayani pengiriman ke seluruh Indonesia melalui ekspedisi terpercaya (JNE, J&T, SiCepat, dll). Biaya pengiriman ditanggung pembeli dan akan diinformasikan sebelum pembayaran. Pengiriman aman dengan packing bubble wrap dan kardus.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id='faq' className='py-20 bg-gray-50'>
      <div className='max-w-4xl mx-auto px-4 sm:px-6 lg:px-8'>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className='text-center mb-16'
        >
          <h2 className='section-title'>Pertanyaan yang Sering Diajukan</h2>
          <p className='section-subtitle'>
            Temukan jawaban untuk pertanyaan umum tentang produk dan layanan kami
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className='space-y-4'
        >
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className='bg-white rounded-2xl shadow-md overflow-hidden'
            >
              <button
                className='w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200'
                onClick={() => toggleFAQ(index)}
              >
                <span className='font-semibold text-gray-900 pr-8'>{faq.question}</span>
                <motion.svg
                  className='w-6 h-6 text-primary-600 shrink-0'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M19 9l-7 7-7-7'
                  />
                </motion.svg>
              </button>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className='overflow-hidden'
                  >
                    <div className='px-6 pb-5 text-gray-600 leading-relaxed'>{faq.answer}</div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>

        {/* Still have questions CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className='mt-12 text-center'
        >
          <p className='text-gray-600 mb-4'>Masih ada pertanyaan?</p>
          <a
            href='https://wa.me/6285235662062?text=Halo,%20saya%20punya%20pertanyaan%20tentang%20ScanKartu'
            className='inline-flex items-center space-x-2 text-primary-600 hover:text-primary-700 font-semibold'
          >
            <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 24 24'>
              <path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z' />
            </svg>
            <span>Hubungi Kami via WhatsApp</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
